const DEFAULT_RESPONSE =
'{"tag": 0, "transaction":null, "transactionId":null, "encodedData":null, "events": null, "account": null}'

export const response = () => JSON.parse(DEFAULT_RESPONSE)
